import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex justify-center align-center h-100"
}
const _hoisted_2 = {
  key: 2,
  class: "d-flex justify-center align-center h-100"
}

import { computed, ref, watch } from 'vue'
import { useTheme } from 'vuetify'
import { useRoute, useRouter } from 'vue-router'
import {
  BaseWebLayout,
  EmptyWebLayout,
  refObservableValue,
  createCtx,
  createBaseLinks,
  handleError,
  useAuthPermissions,
} from '@prodcard/apps-vue'
import { AppAuthService, AppErrorCode, isAppError, BGOperationsService, UpdateDownloadService } from '@prodcard/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    authService: {},
    bgOperationsService: {},
    updateDownloadService: {}
  },
  setup(__props: any) {

const props = __props;



const isInitializedAuthService = refObservableValue(props.authService.isInitialized)
const errorMessageInitializationAuthService = ref<string | undefined>()

const initializeAuthService = async () => {
  const ctx = createCtx()
  try {
    await props.authService.initialize(ctx)
  } catch (e) {
    if (!isAppError(e)) {
      errorMessageInitializationAuthService.value = 'Ошибка инициализации приложения. Попробуйте обновить страницу.'
      return
    }
    if (e.code === AppErrorCode.AUTHORIZATION_NEEDED) {
      redirectToAuthPath()
      return
    }
    errorMessageInitializationAuthService.value = e.message
  }
}

const { currentUser, currentUserRole, currentUserPermissions } = useAuthPermissions(props.authService)

const route = useRoute()
const router = useRouter()
const theme = useTheme()

const toggleTheme = (isDark: boolean) => {
  theme.global.name.value = isDark ? 'dark' : 'light'
  if (isDark) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

const isBaseLayout = computed(() => {
  if (route.meta.layout === 'empty') {
    return false
  }
  return true
})

// authorization requirement check
router.beforeEach(async to => {
  if (!isInitializedAuthService.value) await initializeAuthService()

  if ((to.meta.requiresAuth || to.path === '/') && !currentUser.value) {
    return {
      path: '/authorization',
      query: { redirect: to.fullPath === '/' ? undefined : to.fullPath },
    }
  }

  if (errorMessageInitializationAuthService.value) return false

  return true
})

const logout = async () => {
  if (currentUser.value) {
    await props.authService.logout(createCtx())
  }
}

const redirectToAuthPath = () => {
  handleError(() => router.push({ path: '/authorization', query: { redirect: route.fullPath } }))
}

watch(currentUser, (value, oldValue) => {
  if (!value && oldValue) redirectToAuthPath()
})

const links = createBaseLinks()

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (_unref(isInitializedAuthService) && !errorMessageInitializationAuthService.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isBaseLayout.value)
              ? (_openBlock(), _createBlock(_unref(BaseWebLayout), {
                  key: 0,
                  permissions: _unref(currentUserPermissions),
                  "current-user": _unref(currentUser),
                  "current-role": _unref(currentUserRole),
                  "is-dark-theme": _unref(theme).global.name.value === 'dark',
                  links: _unref(links),
                  "bg-operations-service": _ctx.bgOperationsService,
                  "update-download-service": _ctx.updateDownloadService,
                  onToggleTheme: toggleTheme,
                  onLogout: logout
                }, null, 8, ["permissions", "current-user", "current-role", "is-dark-theme", "links", "bg-operations-service", "update-download-service"]))
              : (_openBlock(), _createBlock(_unref(EmptyWebLayout), { key: 1 }))
          ], 64))
        : (!_unref(isInitializedAuthService) && !errorMessageInitializationAuthService.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "64",
                width: "8"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_alert, {
                "max-width": "500",
                density: "compact",
                type: "error",
                title: "Ошибка.",
                text: errorMessageInitializationAuthService.value
              }, null, 8, ["text"])
            ]))
    ]),
    _: 1
  }))
}
}

})